import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { IReimbursementState } from '../models/reimbursementModel';
import actionTypes from '../types/reimbursementTypes';

const initialState: IReimbursementState = {
  reimbursementDetail: null,
  irModalVisible: false,
  pageIndex: 1,
  filterAction: 'All',
  isOTPModalVisible: false,
};

const reducer = (
  state: any = cloneDeep(initialState),
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SET_REIMBURSEMENT_DETAIL:
      return {
        ...state,
        reimbursementDetail: action.payload,
      };
    case actionTypes.SHOW_IR_MODAL:
      return {
        ...state,
        irModalVisible: action.payload,
      };
    case actionTypes.RESET_REIMBURSEMENT:
      return cloneDeep(initialState);
    case actionTypes.SET_OTP_MODAL_VISIBLE:
      return {
        ...state,
        isOTPModalVisible: action.payload,
      };
    default: return state;
  }
};

export { reducer as reimbursementReducer };
